// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

//全局引入ant design
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
Vue.use(Antd)

//引入Moment.js
import moment from 'moment'
import lodash from 'lodash'
moment.locale('zh-cn')

import QRCode from 'qrcode'
Vue.prototype.QRCode = QRCode

//引入axios
import axios from 'axios'

Vue.prototype.$token_key      = 'ak_token';
Vue.prototype.$admin_name_key = 'ak_admin_name';
let test = false ? true : false;
let host = 'http://dksdk_api_v2.test/';
if (!test) {
  //host = 'https://apiv2.02061208.boneb.net/';
  //host = 'https://api.sdk.zxyx.net/';
  host = 'https://apiv2.sdk2021.gndwc.com/';
  //host = 'https://api2022sdk.yaoc168.com/';
  //host = 'https://api.sdk668899.cqhzhihui.cn';
  //host =  'https://api668899sdk.joy268.com'
  //host =  'https://api668899sdk.joy268.com'
  // host =  'https://api.sanguozizouqi.com'
}
Vue.prototype.$host = host

axios.defaults.baseURL =  Vue.prototype.$host;
// 添加请求拦截器
axios.interceptors.request.use((config) => {
    //如果有就携带token
    let _token = localStorage.getItem(Vue.prototype.$token_key)
    if (_token == null) {
        router.push('/admin/login')
        return config;
    }
    config.headers['Ak-Token'] = _token;
    return config;
}, (error) => {
    // 对请求错误做些什么
    return Promise.reject(error);
});
//接收拦截器
axios.interceptors.response.use((response) => {
    switch(response.data.status){
      case 500:
        router.push('/500')
        break;

      case 403:
        router.push('/403')
        break;

      case 404:
        router.push('/404')
        break;

      case 401:
        router.push('/admin/login')
        break;
    }
    return response;
}, (error) => {
    if (test) {return Promise.reject(error);}
    switch(error.response.status){
      case 500:
        router.push('/500')
        break;

      case 403:
        router.push('/403')
        break;

      case 404:
        router.push('/404')
        break;

      case 401:
        router.push('/admin/login')
        break;
    }
    // 对响应错误做点什么
    return Promise.reject(error);
});

Vue.prototype.$axios  = axios
Vue.prototype.$moment = moment
Vue.prototype.number_format = (num) => {
  if (_.isNil(num) || num == 0 || isNaN(num)) {
    return ''
  }
    num = num + '';
    if (!num.includes('.')) {
        num += '.'
    }
    return num.replace(/(\d)(?=(\d{3})+\.)/g, ($0, $1) => {
        return $1 + ',';
    }).replace(/\.$/, '');
  // console.log(num, num && num.toString().replace(/(?=(?!^)(\d{3})+$)/g, ','))
    // return num && num.toString().replace(/(?=(?!^)(\d{3})+$)/g, ',')
}

Vue.prototype.safeDiv = (num, num2, per = false, fix = 2) => {
  if (_.isNil(num) || _.isNil(num2) || num2 == 0 || isNaN(num) ||  isNaN(num2)) {
    return ''
  }
  let res  = (num/num2)
  if (per) {
    res = (res*100);
  }
  res = Vue.prototype.number_format(res.toFixed(fix));
  if (num == '') {return ''}
  return per ? res + '%' : res
}

Vue.config.productionTip = true;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js